module.exports = "/_next/static/images/half_circle-b5e81ff15838db5fed5e97fe44ecb874.png";